exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Banner {\n    height: 85px;\n    width: 107%;\n    margin-left: -13px;\n    margin-top: 15px;\n    background-size: cover;\n    background-repeat: no-repeat;\n}", ""]);

// exports
